<section
  class="card"
  [class.drag-party]="resourceIds?.length === 0"
  [id]="partyId"
  (click)="cardSelected.emit(true)"
>
  <div class="title unselectable" [style.background]="titleColor">
    <div class="d-flex flex-row justify-content-between align-items-center w-100 title-content">
      <div class="d-flex flex-column justify-content-center align-items-start flex-wrap">
        <p class="names upper" [innerText]="resourceName"></p>
        <div class="d-flex flex-row justify-content-between">
          <tablesready-party-badge
            [party]="partyBadge"
            [showTypeBadge]="partyBadge.type === partyTypes.reservation && type === floorPlanPartyTypes.serving"
          ></tablesready-party-badge>
          <shared-badge
            *ngIf="unpaid"
            [label]="'Unpaid'"
            [class]="'badge badge-pill badge-danger'"
          ></shared-badge>
          <shared-badge
            *ngIf="paid"
            [label]="'Paid'"
            [class]="'badge badge-pill badge-success'"
          ></shared-badge>
        </div>
      </div>


      <div class="d-flex flex-column justify-content-center align-items-end">
        <p class="names pl-2 mb-0" *ngIf="showStatus">({{ type }})</p>

        <span *ngIf="unpaid" class="d-flex flex-row font-weight-bold">
          <span class="pr-1 no-wrap">
            Holding for:
          </span>
          <tablesready-countdoun-timer [milliseconds]="remainingSecondsToPay"></tablesready-countdoun-timer>
        </span>
      </div>
    </div>
  </div>
  <div class="content unselectable">
    <div class="time">
      <tablesready-table-time
        [type]="type"
        [checkInTime]="checkInTime"
        [seatedTime]="seatedTime"
        [quotedTime]="quotedTime"
        [duration]="duration"
        [iconColor]="iconColor"
        [timezone]="timezone"
      ></tablesready-table-time>

      <div class="d-flex flex-row align-items-center">
        <p class="names">{{ customerName }}</p>
      </div>
    </div>

    <div class="guest-count">
      <p>{{ partySize }}</p>
      <p>guests</p>
    </div>
  </div>
</section>
